import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// src/widgetEntry.tsx
import React from 'react';
import ReactDOM from 'react-dom';
import BookingPage from './pages/Public/BookingPage/BookingPage';
import { SnackbarProvider } from './providers/SnackbarProvider';
import { LocationProvider } from './context/LocationContext';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { ConfigProvider } from './context/ConfigContext';
import { ThemeCustomizationProvider } from '@context/ThemeCustomizationProvider';
import { ThemeProvider } from './theme';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { CssBaseline } from '@mui/material';
import ErrorBoundary from './pages/ErrorBoundary';
import { STRIPE_PUBLISHABLE_KEY, API_URL, URL, AUTH0_CLIENT_ID, AUTH0_DOMAIN, AUTH0_INTERNAL_DOMAIN, AWSREGION, MAPBOX_TOKEN, STATE, } from '@settings';
import { MemoryRouter } from 'react-router-dom'; // Direct import of MemoryRouter
// Define default configuration
const defaultConfig = {
    API_URL: API_URL,
    URL: URL,
    AUTH0_CLIENT_ID: AUTH0_CLIENT_ID,
    AUTH0_DOMAIN: AUTH0_DOMAIN,
    AUTH0_INTERNAL_DOMAIN: AUTH0_INTERNAL_DOMAIN,
    AWSREGION: AWSREGION,
    STRIPE_PUBLISHABLE_KEY: STRIPE_PUBLISHABLE_KEY, // Import from settings
    MAPBOX_TOKEN: MAPBOX_TOKEN,
    STATE: STATE,
};
// Define the initialization function
const initBoatBooking = (options) => {
    const { containerId, customerId, initialBoatId, locationId, primaryColor = '#1976D2', backgroundColor = '#FFFFFF', secondaryColor = '#4a4a4a', refAffiliate = '', config = {}, } = options;
    // Merge default config with provided config
    const mergedConfig = Object.assign(Object.assign({}, defaultConfig), config);
    // Find the container element by ID
    const container = document.getElementById(containerId);
    if (!container) {
        console.error(`Container with id "${containerId}" not found.`);
        return;
    }
    // Construct the initial route path
    const initialPath = `/customer/${customerId}/boat/${initialBoatId || ''}`;
    // Append query parameters for theming and affiliate references
    const queryParams = new URLSearchParams({
        primaryColor,
        backgroundColor,
        secondaryColor,
        ref: refAffiliate,
    });
    // Load Stripe if the key is provided
    const stripePromise = mergedConfig.STRIPE_PUBLISHABLE_KEY
        ? loadStripe(mergedConfig.STRIPE_PUBLISHABLE_KEY)
        : null;
    const quarterBack = {
        customerId,
        locationId,
        initialBoatId,
        primaryColor,
        backgroundColor,
        secondaryColor,
        refAffiliate,
    };
    ReactDOM.render(_jsx(React.StrictMode, { children: _jsx(ThemeCustomizationProvider, { children: _jsx(ThemeProvider, { children: _jsx(ErrorBoundary, { children: _jsxs(LocalizationProvider, { dateAdapter: AdapterDayjs, children: [_jsx(CssBaseline, {}), _jsx(SnackbarProvider, { children: _jsx(LocationProvider, { children: _jsx(ConfigProvider, { config: mergedConfig, children: stripePromise ? (_jsx(Elements, { stripe: stripePromise, children: _jsx(MemoryRouter, { initialEntries: [`${initialPath}?${queryParams.toString()}`], children: _jsx(BookingPage, { pass: quarterBack }) }) })) : (_jsx(MemoryRouter, { initialEntries: [`${initialPath}?${queryParams.toString()}`], children: _jsx(BookingPage, {}) })) }) }) })] }) }) }) }) }), container);
};
// Expose the initialization function globally for host websites to call
window.initBoatBooking = initBoatBooking;
